export { default } from "./FontSizeAction";
